import { useMemo } from 'react';
import { SphereGeometry } from 'three';
import { SCALE_IN_TO_UNIT } from '../types';
import { MATERIALS } from '../materials';

interface Props {
  position: [number, number, number];
  refId: string;
}

/**
 * ADJ-15: Aluminium sphere cap at the end of each handrail tube.
 * Represents the real-world elbow / end-fitting that is press-fit or welded
 * at every handrail terminus and junction. Radius matches the 0.75" OD handrail
 * tube visually scaled ×3 (same scale as RailTopTube cross-section).
 * These caps make corner junctions look like a proper assembled fitting rather
 * than two floating tubes that almost-but-don't-quite touch.
 */
const HR_OD_IN = 0.75; // MTR065075031 outer diameter
const VISUAL_SCALE = 3;
const CAP_RADIUS = (HR_OD_IN / 2) * SCALE_IN_TO_UNIT * VISUAL_SCALE;

export function HandrailEndCap({ position, refId }: Props) {
  const geometry = useMemo(() => new SphereGeometry(CAP_RADIUS, 12, 8), []);
  return (
    <mesh
      geometry={geometry}
      material={MATERIALS.aluminumBrushed}
      position={position}
      castShadow
      userData={{ kind: 'handrail-endcap', refId }}
    />
  );
}
